<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Engineering Science"
                   :links="[{title:'Home', url:'/'},{title:'Social Activities'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="11"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">Social Activities</div>
          <activity-component :activity="ac1"></activity-component>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/science/Sidebar";
import ActivityComponent from "@/components/ActivityComponent";
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "Social_Activities",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    ActivityComponent, KeyRecruiters
  },

  data() {
    return {
      ac1: {
        name: "Tree Plantation",
        date: "",
        details: "",
        images: [
          {
            "itemImageSrc": "/static/images/computer/social_activities/ac1/1.jpg",
            "thumbnailImageSrc": "",
            "alt": "Description for Image 1",
            "title": "Title 1"
          },

        ]
      }
    }
  }
}
</script>
<style lang="scss" scoped/>
